import { ReactNode } from 'react'
import { Divider, Grid } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import { StyledTextOrTranslation } from '.'

const useStyles = makeStyles((theme) => ({
  sectionPrimaryText: {
    color: theme.variables.colors.sectionHeader.primary,
    fontSize: theme.variables.fontSizes.section.sectionPrimaryText,
    textTransform: 'uppercase'
  },
  sectionSecondaryText: {
    color: theme.variables.colors.sectionHeader.secondary,
    fontSize: theme.variables.fontSizes.section.sectionSecondaryText
  }
}))

interface SectionHeaderProps {
  isMobile?: boolean
  primaryText?: ReactNode
  primaryTextId?: string
  linkElement?: ReactNode
  secondaryText?: ReactNode
  secondaryTextId?: string
}

export const SectionHeader = ({
  isMobile,
  linkElement,
  primaryText,
  primaryTextId,
  secondaryText,
  secondaryTextId
}: SectionHeaderProps) => {
  const { sectionPrimaryText, sectionSecondaryText } = useStyles()

  const secondaryTextElement = (
    <StyledTextOrTranslation
      text={secondaryText}
      translationId={secondaryTextId}
      typographyProps={{ className: sectionSecondaryText }}
    />
  )

  return (
    <Grid container>
      <Grid item md={true} xs={true}>
        <StyledTextOrTranslation
          text={primaryText}
          translationId={primaryTextId}
          typographyProps={{ className: sectionPrimaryText }}
        />
      </Grid>
      <Grid item md="auto" xs="auto">
        {isMobile ? linkElement : secondaryTextElement}
      </Grid>
      <Grid item md={12} xs={12}>
        <Divider
          sx={{
            borderBottom: (theme) =>
              `2px solid ${theme.variables.colors.sectionHeader.border}`,
            mb: isMobile ? 0 : 1.5
          }}
        />
      </Grid>
      {isMobile && (
        <Grid item xs={12}>
          {secondaryTextElement}
        </Grid>
      )}
    </Grid>
  )
}
